module.exports = __webpack_public_path__ + "pin_purple.2f6f82.png";